<template>
  <v-navigation-drawer
    app
    touchless
    :mini-variant="mini"
    clipped
    permanent
  >
    <template v-slot:prepend>
      <user-menu :mini="mini" />
      <v-divider />
    </template>

    <v-list dense>
      <!-- Home link show only on mobile -->
      <v-list-item
        key="home"
        class="hidden-sm-and-up"
        to="/"
      >
        <v-list-item-action>
          <v-icon>home</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Home</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <template v-for="item in mainNav">
        <v-tooltip
          v-if="item.items && hasRoutePermission(item.link)"
          :key="item.name"
          :disabled="!mini"
          right
        >
          <template v-slot:activator="{ on }">
            <v-list-group
              :prepend-icon="item.icon"
              v-on="on"
            >
              <template v-slot:activator>
                <v-list-item-title>{{ item.name }}</v-list-item-title>
              </template>

              <v-list-item
                v-for="subItem in item.items"
                :key="subItem.name"
                :to="subItem.link"
                active-class="primary--text"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ subItem.name }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon>{{ subItem.icon }}</v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-list-group>
          </template>

          <span>{{ item.name }}</span>
        </v-tooltip>

        <v-tooltip
          v-else-if="hasRoutePermission(item.link)"
          :key="item.name"
          :disabled="!mini"
          right
        >
          <template v-slot:activator="{ on }">
            <v-list-item
              :to="item.link"
              active-class="primary--text"
              v-on="on"
            >
              <v-list-item-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action>

              <v-list-item-content>
                <v-list-item-title>
                  {{ item.name }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>

          <span>{{ item.name }}</span>
        </v-tooltip>
      </template>
    </v-list>

    <template v-slot:append>
      <v-divider />

      <v-list-item
        id="main-nav-icon"
        @click="mini = !mini"
      >
        <v-list-item-action>
          <v-icon>
            {{ mini ? 'chevron_right' : 'chevron_left' }}
          </v-icon>
        </v-list-item-action>

        <v-list-item-content>
          <v-list-item-title class="grey--text text--darken-1">
            {{ config.title }} v{{ config.version }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import config from '@/config'
import { hasRoutePermission } from '@/router'
import UserMenu from './UserMenu'

export default {
  name: 'Sidebar',
  components: {
    UserMenu
  },
  data () {
    return {
      config,
      mini: true
    }
  },
  computed: {
    ...mapState('navigation', [ 'mainNav' ]),
    ...mapGetters('user', [ 'currentUserPlan' ])
  },
  methods: {
    hasRoutePermission
  }
}
</script>

<style lang="scss">
</style>
